import { frontendURL } from '../../../helper/URLHelper';
import StaffChatView from './StaffChatView.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/staff-chat'),
      name: 'staff_chat_list',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: StaffChatView,
      props: () => ({ staffChatId: 0 }),
    },
    {
      path: frontendURL('accounts/:accountId/staff-chat/:staffChatId'),
      name: 'staff_chat_conversation',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: StaffChatView,
      props: route => ({
        staffChatId: Number(route.params.staffChatId),
      }),
    },
  ],
};
